import React from "react";
import FeatherIcon from "feather-icons-react";
import { ReactComponent as Enter } from "../icons/enter.svg";
import { IFilterData, IMenuItem, IMainItem } from "../../@types/types";
import { colors } from "../../utils";
// import useKeyPress from "../../../../hooks/useKeyPress";
import { useAppState } from "../../context/appContex";
import { RecentSearches, MainResults } from "../common/MainSearch";
// import { EventContext } from "direflow-component";

interface SearchDropDownProps {
  closeGlobalSearch: () => void;
  searchResult: IFilterData;
  searchValue: string;
}

const Notification = () => {
  return (
    <div className='notify'>
      <div
        style={{ marginBottom: "15px", display: "flex", alignItems: "center" }}
      >
        <span>Use</span> <span className='key'>⌘+K</span>{" "}
        <span>keyboard shortcut to start searching any time and</span>{" "}
        <span className='key'>esc</span> to dismiss search window.
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>Press</span>
        <span className='key'>
          <Enter /> Enter
        </span>{" "}
        <span>to search for customers, invoices, tasks and products.</span>
      </div>
    </div>
  );
};

const QuickLinks = ({
  links,
}: {
  links: Pick<IMenuItem, "iconClass" | "targetType" | "targetUrl" | "title">[];
}) => {
  return (
    <div className='s-quick-links'>
      {links.map((link, index) => {
        if (link.targetType === "BLANK" || link.targetType === "POPUP") {
          return (
            <a
              href={link.targetUrl}
              target='_blank'
              rel='noopener noreferrer'
              key={link.targetUrl + index.toString()}
              className='s-quick-item'
            >
              <FeatherIcon
                icon={link.iconClass}
                style={{ marginRight: "10px", color: colors[index] }}
                size={16}
              />
              {link.title}
            </a>
          );
        }

        return (
          <a
            href={link.targetUrl}
            key={link.targetUrl + index.toString()}
            className='s-quick-item'
          >
            <FeatherIcon
              icon={link.iconClass}
              style={{ marginRight: "10px", color: colors[index] }}
              size={16}
            />
            {link.title}
          </a>
        );
      })}
    </div>
  );
};

const SearchDropDown: React.FC<SearchDropDownProps> = ({
  closeGlobalSearch,
  searchResult,
  searchValue,
}) => {
  //   const [cursor, setCursor] = useState(-1);
  //   const [hovered, setHovered] = useState<IMainItem | undefined>(undefined);
  //   const [selected, setSelected] = useState<IMainItem | undefined>(undefined);
  //   const downPress = useKeyPress("ArrowDown");
  //   const upPress = useKeyPress("ArrowUp");
  //   const enterPress = useKeyPress("Enter");
  //   const [showEnterKey, setShowEnterKey] = useState(false);

  // const ref = useRef<HTMLDivElement>(null);

  // const dispatch = useContext(EventContext);

  const { clientCode, user } = useAppState();

  const { quickLinks, mainItems } = searchResult;

  //   const refs = useRef<Array<HTMLDivElement>>([]);
  //   refs.current = [];

  //   useEffect(() => {
  //     if (mainItems.length && downPress) {
  //       setCursor((prevState) =>
  //         prevState < mainItems.length - 1 ? prevState + 1 : prevState
  //       );
  //     }
  //   }, [downPress, mainItems]);

  //   useEffect(() => {
  //     if (mainItems.length && upPress) {
  //       setCursor((prevState) => (prevState > 0 ? prevState - 1 : prevState));
  //     }
  //   }, [upPress, mainItems]);

  //   useEffect(() => {
  //     if (mainItems.length && enterPress) {
  //       setSelected(mainItems[cursor]);
  //     }
  //   }, [cursor, enterPress, mainItems]);

  //   useEffect(() => {
  //     if (mainItems.length && hovered) {
  //       setCursor(mainItems.indexOf(hovered));
  //     }
  //   }, [hovered, mainItems]);

  //   useEffect(() => {
  //     setCursor(-1);
  //   }, [searchValue]);

  //   const addToRef = (ele: HTMLDivElement) => {
  //     if (ele && !refs.current.includes(ele)) {
  //       refs.current.push(ele);
  //     }
  //   };

  //   useEffect(() => {
  //     if ((cursor === 0 || cursor > 0) && (upPress || downPress)) {
  //       refs.current[cursor].scrollIntoView({ behavior: "smooth" });
  //     }
  //   }, [cursor, upPress, downPress]);

  const value = sessionStorage.getItem(`recent_search_${clientCode}_${user}`);
  const recentSearches = JSON.parse(
    value ? value : JSON.stringify("")
  ) as IMainItem[];

  return (
    <div className='search-drop-down'>
      <div className='content'>
        {searchValue ? (
          <>
            <QuickLinks links={quickLinks} />
            {recentSearches && recentSearches.length ? (
              <>
                <span className='s-section-header'>Recent searches</span>
                <RecentSearches recentSearches={recentSearches} />
              </>
            ) : null}
            {mainItems.length ? (
              <>
                <span
                  className='s-section-header'
                  style={recentSearches.length ? { marginTop: "40px" } : {}}
                >
                  Results in Menus
                </span>
                <MainResults
                  items={mainItems}
                  //   cursor={cursor}
                  //   onMouseEnter={(item) => {
                  //     setHovered(item);
                  //     setShowEnterKey(true);
                  //   }}
                  //   onMouseLeave={() => {
                  //     setHovered(undefined);
                  //     setShowEnterKey(false);
                  //     setCursor(-1);
                  //   }}
                  searchValue={searchValue}
                  //   showEnterKey={showEnterKey}
                  clientCode={clientCode}
                  user={user}
                  //   addToRef={addToRef}
                />
              </>
            ) : null}
          </>
        ) : (
          <Notification />
        )}
      </div>
      <FeatherIcon
        icon='x'
        className='close-icon'
        onClick={() => {
          const event = new CustomEvent("close-global-search");
          dispatchEvent(event);
          closeGlobalSearch();
        }}
      />
    </div>
  );
};

export default SearchDropDown;
